import { LODGING_PAYMENT_TYPE } from "Constants";
import { action, computed, thunk } from "easy-peasy";
import DashboardModel from "Store/models/dashboard";
import moment from "moment";

var _groupBy = require("lodash/groupBy");

export const ACTION_TYPES = {
  FAILED: 1,
  FINISHED: 2,
  FETCHING_DATA: 5,
  FETCHED_DATA: 6,
};

const TotalLodgingRentPaymentsDashboardModel = {
  chartData: computed((state) => {
    let _chartData = [];

    var data = _groupBy(state.data, function (item) {
      return `${item.month}/${item.year}`;
    });

    let startDate = moment(moment().subtract(6, "months"));
    for (let i = 0; i < 12; i++) {
      let month = startDate.get("M") + 1;
      let year = startDate.get("Y");

      var item = { "Ay/Yıl": `${month}/${year}` };
      item[LODGING_PAYMENT_TYPE.PAID] =
        state.data.find(
          (f) => f.year == year && f.month == month && f.lodgingRent == "PAID"
        )?.totalCount || 0;
      item[LODGING_PAYMENT_TYPE.PARTIALLY_PAID] =
        state.data.find(
          (f) =>
            f.year == year &&
            f.month == month &&
            f.lodgingRent == "PARTIALLY_PAID"
        )?.totalCount || 0;
      item[LODGING_PAYMENT_TYPE.NOT_PAID] =
        state.data.find(
          (f) =>
            f.year == year && f.month == month && f.lodgingRent == "NOT_PAID"
        )?.totalCount || 0;

      _chartData.push(item);

      startDate = startDate.add(1, "months");
    }
    return _chartData;
  }),
  ...DashboardModel("totallodgingrentpayments"),
};

export default TotalLodgingRentPaymentsDashboardModel;
